import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle, faTimes } from '@fortawesome/free-solid-svg-icons';
import { darken } from 'polished';

import { COLOR_THEME } from '../utils/themer';
import {
  BLACK, LIGHT_GREY, RED, WHITE,
} from '../constants/colors';

const Button = styled.button`
  height: 30px;
  padding: 5px 10px;
  background: ${darken(0.1, LIGHT_GREY)};
  border-radius: 15px;
  border: none;
  color: ${BLACK};
  font-weight: bold;
  font-size: 12px;
  margin-right: 10px;
  cursor: pointer;

  &:hover {
    background: ${darken(0.1, RED)};
    color: ${WHITE};
    transition: color 0.15s;

    & .icon {
      display: none;
    }

    & .iconReverse {
      display: inline;
      color: ${WHITE};
    }
  }

  & span {
    margin-right: 5px;
  }

  & .icon {
    color: ${COLOR_THEME.primary};
  }

  & .iconReverse {
    display: none;
  }
`;

function QlikBreadcrumb({ t, action, text }) {
  const key = text.replace('.', '_');
  const field = `CoreFields.${key}`;

  return (
    <Button type="button" onClick={action} content={t(field, text)}>
      <span>{t(field, text)}</span>
      <FontAwesomeIcon className="icon" icon={faTimesCircle} />
      <FontAwesomeIcon className="iconReverse" icon={faTimes} />
    </Button>
  );
}

QlikBreadcrumb.propTypes = {
  t: PropTypes.func.isRequired, // supplied from withTranslation
  action: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
};

export default withTranslation()(QlikBreadcrumb);
